import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { ROUTER_CONFIG } from '@core/configs';
import { checkIs403URL } from '@core/helper';
import { AuthService } from '@core/services/apis';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private _authService: AuthService, private _router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const isRefreshTokenExpired = this._authService.isRefreshTokenExpired;
    if (this._authService.loggedIn() && !isRefreshTokenExpired) {
      if (checkIs403URL(route)) {
        // in case user is logged in open new tab
        // with url existed but user not allow permissions to access
        this._router.navigate([ROUTER_CONFIG.forbidden]);
        return false;
      }
      return true;
    } else {
      this._authService.logout().then();
      return false;
    }
  }
}
